import { render } from "./TaskAlerts.vue?vue&type=template&id=1e5b5427&ts=true"
import script from "./TaskAlerts.ts?vue&type=script&lang=ts&external"
export * from "./TaskAlerts.ts?vue&type=script&lang=ts&external"

import "./TaskAlerts.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__